import { set, when } from 'cerebral/operators'
import redirect from 'cerebral-module-router/redirect'
import closeNavigation from './closeNavigation'

export default [
  redirect('/users/unapproved'),
  set('state:client.currentPage', 'users/unapproved'),
  ...closeNavigation,
  when('state:users.currentView', ['approved']),
  {
    approved: [set('state:users.currentView', 'unapproved')],
    otherwise: []
  }
]



// WEBPACK FOOTER //
// ./src/modules/user/chains/changeToUnapprovedUsers.js